import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rp-home-info-banner',
  standalone: true,
  templateUrl: './info-banner.component.html',
  styleUrl: './info-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class InfoBannerComponent {
  readonly items = [
    'forAffiliates.exclusiveOffers',
    'runningBanner.multilingualManagers',
    'runningBanner.legalTeam',
    'runningBanner.trafficAnalytics',
    'runningBanner.fastPayouts',
  ];
  readonly bannerCount = [1, 2];

  readonly merqueeItems = [...this.items, ...this.items];
}
